export const doctorCardTexts = {
  phone: 'مشاوره تلفنی فوری',
  rx: 'نسخه الکترونیک',
  book: 'رزرو مشاوره',
  onDemandCall: 'انتخاب مدت مشاوره',
  scheduledCall: 'انتخاب زمان مشاوره',
  onDemandChat: 'انتخاب مشاوره',
  onPersonVisit: 'نوبت حضوری',
  bookingNobat: 'رزرو نوبت',
  booking: 'مشاوره آنلاین',
  inPersonBooking: 'دریافت نوبت حضوری',
};

export const similarOnlineDoctorsText = {
  title: 'پزشک‌‌های آنلاین',
  viewAll: 'مشاهده‌ بیشتر',
};

export const similarDoctorsText = {
  title: 'پزشک‌‌ها با تخصص‌مشابه',
  viewAll: 'مشاهده‌ بیشتر',
};

export const onlineDoctorAlertText = {
  description: 'به محض آنلاین شدن پزشک، به شما اطلاع می‌دهیم .',
  NotifyButton: 'آنلاین شد خبرم کن',
  title: 'خبرم کن',
  unloggeddescription:
    'برای اطلاع از آنلاین شدن پزشک شماره تلفن خود را وارد کنید.',
  loggeddescription: 'از طریق پیامک به شما اطلاع رسانی خواهد شد.',
  inputLabel: 'شماره موبایل',
  inputPlaceholder: '۰۹*********',
  unloggedSubmit: 'ثبت',
  cancel: 'انصراف',
  loggedSubmit: 'ثبت اطلاع رسانی',
  phoneNumber: 'شماره شما :',
};
